module.exports = __webpack_public_path__ + "img/sec2_27.e483c580.png";